
<template lang="pug">
q-modal(
  v-model="visible"
  minimized
  no-backdrop-dismiss
)
  .popup-time-range.q-ma-md
    .q-title.q-mb-sm(v-if="params.title") {{params.title}}

    .popup-time-range-notice(v-if="params.notice") {{params.notice}}

    .flex.justify-center.items-end.q-mb-lg
      q-field
        SelectTime(
          ref="focus"
          v-model="begin_time"
          float-label="開始"
          :min="min"
          :max="maxBegin"
        )

      .q-mx-sm 〜

      q-field
        SelectTime(
          v-model="end_time"
          float-label="終了"
          :min="minEnd"
          :max="max"
        )

    .row.reverse.reverse-wrap
      q-btn.q-mx-sm(
        color="dark"
        flat
        v-close-overlay
      ) キャンセル

      q-btn.q-mx-sm(
        :disabled="!canConfirm"
        color="primary"
        flat
        @click="confirm"
      ) 確定

      slot(:params="params")

</template>

<script>
import {isValid, addSeconds, subSeconds} from 'date-fns/esm'

import {timeToObject, timeToString, timeIsValid, isEqualOrBefore, isEqualOrAfter} from 'helpers/date'
import {mapAuto} from 'helpers/vuex-bind'

import SelectTime from 'components/SelectTime'

export default {
  components: {SelectTime},

  props: {
    max: String,
    min: String,
  },

  data() {
    return {
      visible:    false,

      begin_time: null,
      end_time:   null,
      params:     {},
    }
  },

  computed: {
    ...mapAuto(['timeStepMinutes']),

    canConfirm() {
      return timeIsValid(this.begin_time, this.end_time)
    },

    maxBegin() {
      const max = timeToObject(this.max)
      return isValid(max) ? timeToString(subSeconds(max, this.timeStepMinutes)) : null
    },

    minEnd() {
      const min = timeToObject(this.min)
      return isValid(min) ? timeToString(addSeconds(min, this.timeStepMinutes)) : null
    },
  },

  watch: {
    begin_time(value) {
      const time = timeToObject(value)
      const subject = timeToObject(this.end_time)
      if(isValid(time) && isValid(subject) && isEqualOrAfter(time, subject)) {
        this.end_time = timeToString(addSeconds(time, this.timeStepMinutes))
      }
    },

    end_time(value) {
      const time = timeToObject(value)
      const subject = timeToObject(this.begin_time)
      if(isValid(time) && isValid(subject) && isEqualOrBefore(time, subject)) {
        this.begin_time = timeToString(subSeconds(time, this.timeStepMinutes))
      }
    },
  },

  methods: {
    show(begin_time, end_time, params) {
      this.begin_time = begin_time
      this.end_time   = end_time
      this.params     = params

      this.visible = true

      setTimeout(() => {
        this.$refs.focus.$el.focus()
      }, 0)
    },

    hide() {
      this.visible = false
    },

    confirm() {
      // バリデーション

      this.$emit('confirm', this.begin_time, this.end_time, this.params)
    },
  },
}
</script>

<style lang="sass">
.popup-time-range
  width: 280px
</style>
